import React from "react";

const About = () => {
  return (
    <div style={styles.container}>

      {/* TOP SECTION - CENTERED */}
      <div style={styles.centerSection}>
        <h1>About</h1>

        <p style={styles.centerText}>
          ResumeFuel is a fast, modern platform designed to help you create professional
          resumes that truly stand out.
        </p>

        <p style={styles.centerText}>
          We simplify resume building for students, freshers, and professionals so you can
          create job-ready resumes in minutes without stress.
        </p>
      </div>

      {/* SECTION 1 - IMAGE LEFT */}
      <div style={styles.row}>
        <img class="abt-img"
          src="https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator2.png"
          alt="Resume templates"
          style={styles.image}
        />

        <div style={styles.textBox}>
          <h2>What We Offer</h2>
          <ul style={styles.list}>
            <li>Clean and modern resume templates</li>
            <li>Simple interface with real-time preview</li>
            <li>Quick and flexible customization</li>
            <li>Export-ready resumes for job applications</li>
          </ul>
        </div>
      </div>

      {/* SECTION 2 - IMAGE RIGHT */}
      <div style={{ ...styles.row, flexDirection: "row-reverse" }}>
        <img class="abt-img"
          src="https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator1.png"
          alt="Resume builder"
          style={styles.image}
        />

        <div style={styles.textBox}>
          <h2>Why ResumeFuel?</h2>
          <p>
            Because your time matters. Instead of struggling with layout and design,
            ResumeFuel helps you focus on what really counts—your experience, skills,
            and future goals.
          </p>

          <p>
            Start building your resume today and take the next step toward your career success.
          </p>
        </div>
      </div>

    </div>
  );
};

const styles = {
  container: {
    margin: "auto",
    padding: "30px",
  },

  centerSection: {
    textAlign: "center",
    marginBottom: "50px",
  },

  centerText: {
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "10px",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "30px",
    marginBottom: "60px",
    flexWrap: "wrap",
  },

  image: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "10px",
    objectFit: "cover",
    flex: "1",
  },

  textBox: {
    flex: "1",
    minWidth: "280px",
  },
  list: {
     marginLeft: "-17px",   
  }
};

export default About;